import React, { useEffect, useState } from 'react';

/**
 * Map controller snapshot → React view fields used by the bell.
 * @param {ReturnType<import('./adminProspectResponseNotifications.js').createAdminProspectResponseNotificationsController> extends never ? any : object} snap
 */
export function mapNotificationControllerSnapshotToView(snap) {
  return {
    items: snap?.items || [],
    nextPageToken: snap?.nextPageToken ?? null,
    configured: snap?.configured !== false,
    unreadCount: Number(snap?.unreadCount) || 0,
    listStatus: snap?.listStatus || 'idle',
    errorKey: snap?.errorKey ?? null,
    markingIds: snap?.markingIds instanceof Set ? snap.markingIds : new Set(),
  };
}

/**
 * Lifecycle-safe React subscription to the production notifications controller.
 * Publishes operation-start busy state and coalesced soft-refresh completions.
 * @param {{ subscribe?: Function, getState?: Function } | null | undefined} controller
 */
export function useAdminProspectResponseNotificationsView(controller) {
  const [view, setView] = useState(() =>
    mapNotificationControllerSnapshotToView(controller?.getState?.()),
  );

  useEffect(() => {
    if (!controller?.subscribe) {
      setView(mapNotificationControllerSnapshotToView(controller?.getState?.()));
      return undefined;
    }
    return controller.subscribe((snap) => {
      setView(mapNotificationControllerSnapshotToView(snap));
    });
  }, [controller]);

  return view;
}
